<template>
  <div class="trade-in-modern">
    <div class="hero-section">
      <div class="hero-overlay"></div>
      <div class="container">
        <el-breadcrumb class="breadcrumb">
          <el-breadcrumb-item
            ><span class="breadcrumb_span" @click="backHome"
              >政务服务</span
            ></el-breadcrumb-item
          >
          <el-breadcrumb-item>以旧换新</el-breadcrumb-item>
        </el-breadcrumb>
        <h1 class="hero-title">家电以旧换新补贴政策</h1>
        <p class="hero-subtitle">绿色消费 · 节能减排 · 政府补贴</p>
        <div class="hero-stats">
          <div class="stat-item" v-for="stat in heroStats" :key="stat.id">
            <div class="stat-value">{{ stat.value }}</div>
            <div class="stat-label">{{ stat.label }}</div>
          </div>
        </div>
      </div>
    </div>

    <div class="container">
      <!-- 主要内容区 -->
      <div class="content-layout">
        <!-- 左侧主内容 -->
        <div class="main-content">
          <!-- 政策介绍卡片 -->
          <el-card shadow="never" class="policy-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-notebook-2"></i>
              </div>
              <h2>政策介绍</h2>
              <el-tag type="success" effect="plain">政府支持</el-tag>
            </div>

            <div class="policy-content">
              <p>
                为促进绿色消费和资源循环利用，国家推出家电以旧换新补贴政策，鼓励消费者淘汰高能耗旧家电，购买节能环保新产品。
              </p>

              <div class="policy-highlights">
                <div
                  class="highlight-item"
                  v-for="(item, index) in policyHighlights"
                  :key="index"
                >
                  <div
                    class="highlight-icon"
                    :style="{ backgroundColor: item.color }"
                  >
                    <i :class="item.icon"></i>
                  </div>
                  <div class="highlight-content">
                    <h3>{{ item.title }}</h3>
                    <p>{{ item.content }}</p>
                  </div>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 补贴标准 -->
          <el-card shadow="never" class="subsidy-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-finance"></i>
              </div>
              <h2>补贴标准</h2>
              <el-tag type="warning" effect="plain">2023年标准</el-tag>
            </div>

            <div class="subsidy-table">
              <el-table :data="subsidyStandards" style="width: 100%">
                <el-table-column prop="category" label="产品类别" width="180">
                  <template slot-scope="scope">
                    <div class="product-category">
                      <i
                        :class="scope.row.icon"
                        :style="{ color: scope.row.color }"
                      ></i>
                      {{ scope.row.category }}
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="standard" label="补贴标准">
                  <template slot-scope="scope">
                    <div class="subsidy-amount">
                      <span class="amount">{{ scope.row.standard }}</span>
                      <span class="condition" v-if="scope.row.condition"
                        >({{ scope.row.condition }})</span
                      >
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="limit" label="限额" width="120">
                  <template slot-scope="scope">
                    <el-tag v-if="scope.row.limit" size="small">{{
                      scope.row.limit
                    }}</el-tag>
                  </template>
                </el-table-column>
              </el-table>
            </div>

            <div class="subsidy-tip">
              <i class="el-icon-info"></i>
              补贴可与商家促销活动叠加使用，每人每年最多享受3次补贴
            </div>
          </el-card>

          <!-- 申请流程 -->
          <el-card shadow="never" class="process-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-operation"></i>
              </div>
              <h2>申请流程</h2>
              <el-tag type="info" effect="plain">5个步骤</el-tag>
            </div>

            <div class="process-steps">
              <div
                class="process-step"
                v-for="(step, index) in processSteps"
                :key="index"
                :style="{ '--step-color': step.color }"
              >
                <div class="step-number">{{ index + 1 }}</div>
                <div class="step-content">
                  <div class="step-header">
                    <h3>{{ step.title }}</h3>
                    <el-tag v-if="step.time" size="small">{{
                      step.time
                    }}</el-tag>
                  </div>
                  <p>{{ step.description }}</p>
                  <div class="step-tips" v-if="step.tips">
                    <div class="tip-title">小贴士：</div>
                    <div class="tip-content">{{ step.tips }}</div>
                  </div>
                </div>
              </div>
            </div>
          </el-card>

          <!-- 申请表单 -->
          <el-card shadow="never" class="form-card glassmorph" v-if="showForm">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-edit"></i>
              </div>
              <h2>补贴申请</h2>
            </div>

            <el-form
              :model="form"
              :rules="rules"
              ref="formRef"
              label-position="top"
              class="trade-in-form"
            >
              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="申请人姓名" prop="name">
                    <el-input
                      v-model="form.name"
                      placeholder="请输入申请人姓名"
                      prefix-icon="el-icon-user"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="身份证号" prop="idCard">
                    <el-input
                      v-model="form.idCard"
                      placeholder="请输入身份证号码"
                      prefix-icon="el-icon-postcard"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-row :gutter="20">
                <el-col :md="12" :sm="24">
                  <el-form-item label="联系电话" prop="phone">
                    <el-input
                      v-model="form.phone"
                      placeholder="请输入联系电话"
                      prefix-icon="el-icon-phone"
                    >
                    </el-input>
                  </el-form-item>
                </el-col>

                <el-col :md="12" :sm="24">
                  <el-form-item label="所在地区" prop="region">
                    <el-cascader
                      v-model="form.region"
                      :options="regions"
                      placeholder="请选择所在地区"
                      style="width: 100%"
                    >
                    </el-cascader>
                  </el-form-item>
                </el-col>
              </el-row>

              <el-form-item label="旧家电信息" prop="oldAppliance">
                <el-row :gutter="20">
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="oldCategory" class="no-margin">
                      <el-select
                        v-model="form.oldCategory"
                        placeholder="家电类别"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in applianceCategories"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="oldBrand" class="no-margin">
                      <el-input v-model="form.oldBrand" placeholder="品牌">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="oldAge" class="no-margin">
                      <el-input v-model="form.oldAge" placeholder="使用年限">
                        <template slot="append">年</template>
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item label="新家电信息" prop="newAppliance">
                <el-row :gutter="20">
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="newCategory" class="no-margin">
                      <el-select
                        v-model="form.newCategory"
                        placeholder="家电类别"
                        style="width: 100%"
                      >
                        <el-option
                          v-for="item in applianceCategories"
                          :key="item.value"
                          :label="item.label"
                          :value="item.value"
                        >
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="newBrand" class="no-margin">
                      <el-input v-model="form.newBrand" placeholder="品牌">
                      </el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :md="8" :sm="24">
                    <el-form-item prop="invoiceNumber" class="no-margin">
                      <el-input
                        v-model="form.invoiceNumber"
                        placeholder="发票号码"
                      >
                      </el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-form-item>

              <el-form-item label="旧家电照片" prop="oldImages">
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :on-change="handleOldImageChange"
                  :file-list="form.oldImages"
                  :limit="3"
                  multiple
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="upload-tip">
                  请上传旧家电正面、型号标签和能效标识照片（最多3张）
                </div>
              </el-form-item>

              <el-form-item label="新家电发票" prop="invoiceImage">
                <el-upload
                  action="#"
                  list-type="picture-card"
                  :auto-upload="false"
                  :on-change="handleInvoiceChange"
                  :file-list="form.invoiceImage"
                  :limit="1"
                >
                  <i class="el-icon-plus"></i>
                </el-upload>
                <div class="upload-tip">
                  请上传新家电购买发票照片（需清晰显示购买日期和金额）
                </div>
              </el-form-item>

              <el-form-item label="回收方式" prop="recycleMethod">
                <el-radio-group v-model="form.recycleMethod">
                  <el-radio-button label="self">自行送交</el-radio-button>
                  <el-radio-button label="pickup">上门回收</el-radio-button>
                </el-radio-group>
              </el-form-item>

              <el-form-item
                label="回收点选择"
                prop="recycleLocation"
                v-if="form.recycleMethod === 'self'"
              >
                <el-select
                  v-model="form.recycleLocation"
                  placeholder="请选择回收点"
                  style="width: 100%"
                >
                  <el-option
                    v-for="loc in recycleLocations"
                    :key="loc.id"
                    :label="loc.name"
                    :value="loc.id"
                  >
                    <div class="location-option">
                      <span>{{ loc.name }}</span>
                      <span class="location-address">{{ loc.address }}</span>
                    </div>
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item
                label="预约时间"
                prop="appointmentTime"
                v-if="form.recycleMethod === 'pickup'"
              >
                <el-date-picker
                  v-model="form.appointmentTime"
                  type="datetime"
                  placeholder="选择预约时间"
                  style="width: 100%"
                  value-format="yyyy-MM-dd HH:mm:ss"
                >
                </el-date-picker>
              </el-form-item>

              <el-form-item>
                <el-button
                  type="primary"
                  size="large"
                  @click="submitForm"
                  class="submit-btn"
                >
                  <i class="el-icon-s-claim"></i> 提交申请
                </el-button>
                <el-button size="large" @click="resetForm"> 重置 </el-button>
              </el-form-item>
            </el-form>
          </el-card>

          <!-- 申请按钮 -->
          <div class="action-buttons" v-if="!showForm">
            <el-button
              type="primary"
              size="large"
              @click="showForm = true"
              class="apply-btn"
            >
              <i class="el-icon-edit"></i> 立即申请补贴
            </el-button>
            <el-button size="large" @click="downloadGuide" class="download-btn">
              <i class="el-icon-download"></i> 下载申请指南
            </el-button>
          </div>
        </div>

        <!-- 右侧边栏 -->
        <div class="sidebar">
          <!-- 参与品牌 -->
          <el-card shadow="never" class="brands-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-s-shop"></i>
              </div>
              <h2>参与品牌</h2>
              <el-tag type="info" effect="plain"
                >{{ brands.length }}个品牌</el-tag
              >
            </div>

            <div class="brands-grid">
              <div
                class="brand-item"
                v-for="brand in brands"
                :key="brand.id"
                @click="viewBrand(brand)"
              >
                <el-image :src="brand.logo" fit="contain" class="brand-logo">
                  <div slot="error" class="image-slot">
                    <i class="el-icon-picture-outline"></i>
                  </div>
                </el-image>
                <div class="brand-name">{{ brand.name }}</div>
              </div>
            </div>
          </el-card>

          <!-- 常见问题 -->
          <el-card shadow="never" class="faq-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-question"></i>
              </div>
              <h2>常见问题</h2>
            </div>

            <el-collapse accordion>
              <el-collapse-item
                v-for="(faq, index) in faqs"
                :key="index"
                :title="faq.question"
                :name="index"
              >
                <div class="faq-answer" v-html="faq.answer"></div>
              </el-collapse-item>
            </el-collapse>
          </el-card>

          <!-- 相关服务 -->
          <el-card shadow="never" class="related-card glassmorph">
            <div class="card-header">
              <div class="header-icon">
                <i class="el-icon-connection"></i>
              </div>
              <h2>相关服务</h2>
            </div>

            <div class="service-list">
              <div
                class="service-item"
                v-for="service in relatedServices"
                :key="service.id"
                @click="$router.push(service.path)"
              >
                <div
                  class="service-icon"
                  :style="{ backgroundColor: service.color }"
                >
                  <i :class="service.icon"></i>
                </div>
                <div class="service-content">
                  <h3>{{ service.title }}</h3>
                  <p>{{ service.desc }}</p>
                </div>
                <i class="el-icon-arrow-right"></i>
              </div>
            </div>
          </el-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollTop } from '@/util/scrollTop';
export default {
  name: 'TradeInModern',
  data() {
    return {
      showForm: false,
      heroStats: [
        { id: 1, value: '¥200-800', label: '单件补贴金额' },
        { id: 2, value: '5-10天', label: '平均处理周期' },
        { id: 3, value: '95%', label: '用户满意度' },
      ],
      policyHighlights: [
        {
          icon: 'el-icon-s-opportunity',
          title: '政策目标',
          content: '促进绿色消费，推动家电行业转型升级，提高资源利用效率',
          color: '#409EFF',
        },
        {
          icon: 'el-icon-s-flag',
          title: '实施时间',
          content: '2023年1月1日至2025年12月31日',
          color: '#67C23A',
        },
        {
          icon: 'el-icon-s-check',
          title: '参与条件',
          content: '中国大陆居民，购买符合条件的新家电并交售旧家电',
          color: '#E6A23C',
        },
      ],
      subsidyStandards: [
        {
          category: '电视机',
          icon: 'el-icon-monitor',
          color: '#409EFF',
          standard: '¥300-500',
          condition: '屏幕尺寸≥43英寸',
          limit: '每台',
        },
        {
          category: '冰箱',
          icon: 'el-icon-refrigerator',
          color: '#67C23A',
          standard: '¥400-600',
          condition: '容积≥200L',
          limit: '每台',
        },
        {
          category: '洗衣机',
          icon: 'el-icon-watermelon',
          color: '#E6A23C',
          standard: '¥300-500',
          condition: '容量≥8kg',
          limit: '每台',
        },
        {
          category: '空调',
          icon: 'el-icon-cold-drink',
          color: '#F56C6C',
          standard: '¥500-800',
          condition: '能效等级1级',
          limit: '每台',
        },
        {
          category: '电脑',
          icon: 'el-icon-laptop',
          color: '#9966CC',
          standard: '¥200-400',
          condition: '台式机/笔记本',
          limit: '每台',
        },
      ],
      processSteps: [
        {
          title: '购买新家电',
          description: '在参与活动的商家购买符合条件的新家电',
          time: '',
          tips: '购买前确认商家参与以旧换新活动',
          color: '#409EFF',
        },
        {
          title: '提交申请',
          description: '在线填写以旧换新补贴申请表',
          time: '',
          tips: '准备新旧家电信息、购买发票等材料',
          color: '#67C23A',
        },
        {
          title: '旧家电回收',
          description: '按选择的方式交售旧家电',
          time: '1-3个工作日',
          tips: '确保旧家电主要部件完整，能正常开机',
          color: '#E6A23C',
        },
        {
          title: '审核确认',
          description: '工作人员审核申请材料',
          time: '3-5个工作日',
          tips: '保持电话畅通以便接收审核通知',
          color: '#F56C6C',
        },
        {
          title: '补贴发放',
          description: '审核通过后发放补贴',
          time: '7个工作日内',
          tips: '补贴将原路返回到支付账户',
          color: '#9966CC',
        },
      ],
      brands: [
        {
          id: 1,
          name: '海尔',
          logo: 'https://pic9.sucaisucai.com/14/79/14079739_2.jpg',
        },
        {
          id: 2,
          name: '美的',
          logo: 'https://img.51miz.com/Element/00/79/50/01/ecc07509_E795001_bacd11d8.png',
        },
        {
          id: 3,
          name: '格力',
          logo: 'https://img.51miz.com/Element/00/86/50/67/ee8e6ef8_E865067_80dcd2fb.png',
        },
        {
          id: 4,
          name: 'TCL',
          logo: 'https://ts1.tc.mm.bing.net/th/id/R-C.7fa37f10ea71f1c6d54d98ef6661186c?rik=qs%2ftO%2fmyZCZorg&riu=http%3a%2f%2fwww.kuaipng.com%2fUploads%2fpic%2fw%2f2023%2f08-06%2f144631%2fwater_144631_698_698_.png&ehk=FOadsdpimTZvCtf%2bNCf44u8TGKD5oeESLw0Ws21Ur3M%3d&risl=&pid=ImgRaw&r=0',
        },
        {
          id: 5,
          name: '创维',
          logo:'https://tse4-mm.cn.bing.net/th/id/OIP-C.Y-xche84Dqdjq57MStE_OAHaFI?rs=1&pid=ImgDetMain',
        },
        {
          id: 6,
          name: '海信',
          logo: 'https://www.sj51.net/wp-content/uploads/2023/01/2023011913182912.png',
        },
      ],
      applianceCategories: [
        { value: 'tv', label: '电视机' },
        { value: 'refrigerator', label: '冰箱' },
        { value: 'washer', label: '洗衣机' },
        { value: 'air_conditioner', label: '空调' },
        { value: 'computer', label: '电脑' },
        { value: 'water_heater', label: '热水器' },
      ],
      regions: [
        {
          value: 'zhejiang',
          label: '浙江省',
          children: [
            { value: 'hangzhou', label: '杭州市' },
            { value: 'ningbo', label: '宁波市' },
          ],
        },
        {
          value: 'jiangsu',
          label: '江苏省',
          children: [
            { value: 'nanjing', label: '南京市' },
            { value: 'suzhou', label: '苏州市' },
          ],
        },
      ],
      recycleLocations: [
        {
          id: 1,
          name: '城东环保回收中心',
          address: 'XX市城东区环保路88号',
        },
        {
          id: 2,
          name: '城南家电回收站',
          address: 'XX市城南区工业园66号',
        },
        {
          id: 3,
          name: '城北资源再生站',
          address: 'XX市城北区绿园路33号',
        },
      ],
      form: {
        name: '',
        idCard: '',
        phone: '',
        region: [],
        oldCategory: '',
        oldBrand: '',
        oldAge: '',
        newCategory: '',
        newBrand: '',
        invoiceNumber: '',
        oldImages: [],
        invoiceImage: [],
        recycleMethod: 'self',
        recycleLocation: '',
        appointmentTime: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入申请人姓名', trigger: 'blur' },
        ],
        idCard: [
          { required: true, message: '请输入身份证号码', trigger: 'blur' },
          {
            pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
            message: '身份证号码格式不正确',
            trigger: 'blur',
          },
        ],
        phone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          {
            pattern: /^1[3-9]\d{9}$/,
            message: '手机号码格式不正确',
            trigger: 'blur',
          },
        ],
        region: [
          { required: true, message: '请选择所在地区', trigger: 'change' },
        ],
        oldCategory: [
          { required: true, message: '请选择旧家电类别', trigger: 'change' },
        ],
        oldBrand: [
          { required: true, message: '请输入旧家电品牌', trigger: 'blur' },
        ],
        newCategory: [
          { required: true, message: '请选择新家电类别', trigger: 'change' },
        ],
        newBrand: [
          { required: true, message: '请输入新家电品牌', trigger: 'blur' },
        ],
        invoiceNumber: [
          { required: true, message: '请输入发票号码', trigger: 'blur' },
        ],
        recycleLocation: [
          { required: true, message: '请选择回收地点', trigger: 'change' },
        ],
        appointmentTime: [
          { required: true, message: '请选择预约时间', trigger: 'change' },
        ],
      },
      faqs: [
        {
          question: '哪些家电可以参与以旧换新？',
          answer:
            '目前支持电视机、冰箱、洗衣机、空调、电脑、热水器等常见家电产品。具体产品范围可能因地区政策有所不同，请咨询当地商务部门。',
        },
        {
          question: '旧家电需要满足什么条件？',
          answer:
            '1. 主要部件完整<br>2. 能正常开机使用<br>3. 符合国家安全使用年限要求<br>4. 非假冒伪劣产品',
        },
        {
          question: '补贴如何发放？',
          answer:
            '补贴将在审核通过后7个工作日内，通过原支付渠道返还或直接发放至指定银行账户。',
        },
        {
          question: '可以同时享受商家折扣和政府补贴吗？',
          answer:
            '可以。政府补贴与商家促销活动可叠加使用，但部分商家可能有特殊规定，建议购买前咨询清楚。',
        },
      ],
      relatedServices: [
        {
          id: 1,
          title: '报废汽车回收',
          desc: '专业汽车报废回收服务',
          icon: 'el-icon-truck',
          path: '/scrap-car',
          color: '#409EFF',
        },
        {
          id: 2,
          title: '再生资源补贴',
          desc: '查询各类再生资源补贴',
          icon: 'el-icon-shopping-bag-2',
          path: '/subsidy',
          color: '#67C23A',
        },
        {
          id: 3,
          title: '环保政策查询',
          desc: '最新环保政策法规',
          icon: 'el-icon-notebook-2',
          path: '/policy',
          color: '#E6A23C',
        },
      ],
    };
  },
  mounted() {
    scrollTop();
  },
  methods: {
    handleOldImageChange(file, fileList) {
      this.form.oldImages = fileList;
    },
    handleInvoiceChange(file, fileList) {
      this.form.invoiceImage = fileList;
    },
    submitForm() {
      this.$refs.formRef.validate((valid) => {
        if (valid) {
          this.$message.success('申请提交成功！');
          this.showForm = false;
          // 这里可以添加API调用
        }
      });
    },
    resetForm() {
      this.$refs.formRef.resetFields();
      this.form.oldImages = [];
      this.form.invoiceImage = [];
    },
    downloadGuide() {
      this.$message.success('开始下载申请指南');
      // 这里可以添加下载逻辑
    },
    viewBrand(brand) {
      this.$message.info(`查看 ${brand.name} 品牌详情`);
      // 实际项目中可以跳转到品牌详情页
    },
    backHome() {
      this.$emit('goBack', '');
    },
  },
};
</script>

<style lang="less" scoped>
.trade-in-modern {
  background-color: #f8fafc;
  min-height: 100vh;
  margin-bottom: 60px;
}

.container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
}
.hero-section {
  background: url('~@/assets/recycling/componyImages/yijiuhuanxin.png');
  background-size: cover;
  background-position: center;
  color: white;
  padding: 65px 0 65px;
  position: relative;
  margin-bottom: -40px;
}

.hero-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(
    135deg,
    rgba(64, 158, 255, 0.8) 0%,
    rgba(103, 194, 58, 0.6) 100%
  );
  z-index: 0;
}

.hero-section > .container {
  position: relative;
  z-index: 1;
}

.breadcrumb /deep/ .el-breadcrumb__item {
  color: rgba(255, 255, 255, 0.8);
}
.breadcrumb_span {
  color: #000000;
  font-weight: 500;
  cursor: pointer;
}

.breadcrumb /deep/ .el-breadcrumb__item:last-child {
  color: white;
  font-weight: bold;
}

.breadcrumb /deep/ .el-breadcrumb__separator {
  color: rgba(255, 255, 255, 0.6);
}

.hero-title {
  font-size: 36px;
  font-weight: 600;
  margin: 20px 0 10px;
  line-height: 1.2;
}

.hero-subtitle {
  font-size: 18px;
  opacity: 0.9;
  margin: 0 0 30px;
  font-weight: 300;
}

.hero-stats {
  display: flex;
  gap: 30px;
  margin-top: 40px;
}

.stat-item {
  text-align: center;
}

.stat-value {
  font-size: 28px;
  font-weight: bold;
  line-height: 40px;
  margin-bottom: 8px;
  color: white;
}

.stat-label {
  font-size: 14px;
  opacity: 0.9;
}

/* 内容布局 */
.content-layout {
  display: flex;
  gap: 24px;
  position: relative;
  z-index: 1;
}

.main-content {
  flex: 1;
  min-width: 0;
}

.sidebar {
  width: 360px;
  flex-shrink: 0;
}

@media (max-width: 992px) {
  .content-layout {
    flex-direction: column;
  }

  .sidebar {
    width: 100%;
  }
}

/* 卡片设计 */
.glassmorph {
  background: rgba(255, 255, 255, 0.9);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  border: 1px solid rgba(255, 255, 255, 0.2);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.05);
  margin-bottom: 24px;
  transition: all 0.3s ease;
}

.glassmorph:hover {
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
  transform: translateY(-2px);
}

.el-card {
  border: none;
  border-radius: 12px;
}

.el-card /deep/ .el-card__body {
  padding: 24px;
}

.card-header {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}

.header-icon {
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: linear-gradient(135deg, #409eff 0%, #66b1ff 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 12px;
  font-size: 18px;
}

.card-header h2 {
  font-size: 20px;
  margin: 0;
  color: #333;
  flex: 1;
}

/* 政策亮点 */
.policy-highlights {
  display: grid;
  gap: 16px;
  margin-top: 20px;
}

.highlight-item {
  display: flex;
  align-items: flex-start;
  padding: 16px;
  background: rgba(250, 250, 252, 0.8);
  border-radius: 8px;
  transition: all 0.3s;
}

.highlight-item:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
}

.highlight-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-right: 16px;
  flex-shrink: 0;
}

.highlight-content h3 {
  font-size: 16px;
  margin: 0 0 8px;
  color: #333;
}

.highlight-content p {
  font-size: 14px;
  margin: 0;
  color: #666;
  line-height: 1.5;
}

/* 补贴表格 */
.subsidy-table /deep/ .el-table {
  border-radius: 8px;
  overflow: hidden;
}

.subsidy-table /deep/ .el-table th {
  background-color: #f5f7fa;
}

.product-category {
  display: flex;
  align-items: center;
}

.product-category i {
  font-size: 20px;
  margin-right: 8px;
}

.subsidy-amount {
  display: flex;
  align-items: center;
}

.amount {
  font-weight: bold;
  color: #e6a23c;
}

.condition {
  font-size: 12px;
  color: #999;
  margin-left: 6px;
}

.subsidy-tip {
  margin-top: 20px;
  padding: 12px;
  background: rgba(64, 158, 255, 0.1);
  border-radius: 6px;
  color: #409eff;
  font-size: 13px;
  display: flex;
  align-items: center;
}

.subsidy-tip i {
  margin-right: 8px;
  font-size: 16px;
}

/* 流程步骤 */
.process-steps {
  display: grid;
  gap: 20px;
}

.process-step {
  display: flex;
  position: relative;
  padding-left: 56px;
}

.process-step::before {
  content: '';
  position: absolute;
  left: 28px;
  top: 0;
  bottom: 0;
  width: 2px;
  background: linear-gradient(
    to bottom,
    var(--step-color),
    rgba(var(--step-color), 0.3)
  );
  opacity: 0.3;
}

.process-step:last-child::before {
  display: none;
}

.step-number {
  position: absolute;
  left: 0;
  width: 40px;
  height: 40px;
  border-radius: 50%;
  background: white;
  border: 2px solid var(--step-color);
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: var(--step-color);
  z-index: 1;
  box-shadow: 0 4px 12px rgba(var(--step-color), 0.2);
}

.step-content {
  padding-bottom: 24px;
}

.step-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.step-header h3 {
  font-size: 16px;
  margin: 0 10px 0 0;
  font-weight: 600;
  color: var(--step-color);
}

.step-content p {
  font-size: 14px;
  margin: 0 0 8px;
  color: #666;
  line-height: 1.6;
}

.step-tips {
  margin-top: 12px;
  padding: 10px;
  background: rgba(var(--step-color), 0.05);
  border-radius: 6px;
  border-left: 3px solid var(--step-color);
}

.tip-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--step-color);
  margin-bottom: 4px;
}

.tip-content {
  font-size: 13px;
  color: #666;
}

/* 表单样式 */
.trade-in-form /deep/ .el-form-item__label {
  font-weight: 500;
  color: #555;
  padding-bottom: 8px;
}

/* 表单输入框样式 */
.trade-in-form /deep/ .el-input__inner {
  height: 44px;
  border-radius: 8px;
  transition: all 0.3s;
}

.trade-in-form /deep/ .el-input__inner:focus {
  border-color: #409eff;
  box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.2);
}

.trade-in-form /deep/ .el-input__prefix,
.trade-in-form /deep/ .el-input__suffix {
  display: flex;
  align-items: center;
}

/* 单选按钮组样式 */
.trade-in-form /deep/ .el-radio-button__inner {
  border-radius: 8px !important;
  transition: all 0.3s;
}

.trade-in-form /deep/ .el-radio-button:first-child .el-radio-button__inner {
  border-left: 1px solid #dcdfe6;
}

.trade-in-form
  /deep/
  .el-radio-button__orig-radio:checked
  + .el-radio-button__inner {
  background-color: #409eff;
  border-color: #409eff;
  box-shadow: none;
}

/* 上传组件样式 */
.trade-in-form /deep/ .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
  border-radius: 8px;
  background-color: #f5f7fa;
  border: 1px dashed #d9d9d9;
}

.trade-in-form /deep/ .el-upload--picture-card:hover {
  border-color: #409eff;
}

.trade-in-form /deep/ .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
  border-radius: 8px;
}

.upload-tip {
  font-size: 12px;
  color: #999;
  margin-top: 8px;
  line-height: 1.5;
}

/* 操作按钮样式 */
.action-buttons {
  display: flex;
  gap: 16px;
  margin: 30px 0;
}

.apply-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: linear-gradient(90deg, #409eff, #66b1ff);
  border: none;
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
  transition: all 0.3s;
}

.apply-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(64, 158, 255, 0.4);
}

.download-btn {
  padding: 0 30px;
  height: 48px;
  font-size: 16px;
  border-radius: 8px;
  background: white;
  border: 1px solid #dcdfe6;
  transition: all 0.3s;
}

.download-btn:hover {
  color: #409eff;
  border-color: #409eff;
}

.submit-btn {
  width: 180px;
  height: 44px;
  font-size: 16px;
  border-radius: 8px;
  transition: all 0.3s;
}

.submit-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(64, 158, 255, 0.3);
}

/* 品牌展示区域 */
.brands-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.brand-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.brand-item:hover {
  background: rgba(64, 158, 255, 0.05);
  transform: translateY(-2px);
}

.brand-logo {
  width: 60px;
  height: 60px;
  margin-bottom: 8px;
  border-radius: 8px;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
}

.brand-name {
  font-size: 14px;
  color: #333;
  text-align: center;
}

.image-slot {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  color: #999;
  font-size: 24px;
}

/* 常见问题样式 */
.faq-card /deep/ .el-collapse-item__header {
  font-size: 15px;
  font-weight: 500;
  padding: 12px 0;
  border-bottom: 1px dashed #ebeef5;
  transition: all 0.3s;
}

.faq-card /deep/ .el-collapse-item__header:hover {
  color: #409eff;
}

.faq-card /deep/ .el-collapse-item__wrap {
  border-bottom: none;
}

.faq-answer {
  padding-right: 20px;
  font-size: 14px;
  color: #666;
  line-height: 1.8;
}

/* 相关服务列表 */
.service-list {
  display: grid;
  gap: 12px;
}

.service-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.3s;
}

.service-item:hover {
  background: rgba(64, 158, 255, 0.05);
  transform: translateX(4px);
}

.service-icon {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  margin-right: 12px;
}

.service-content {
  flex: 1;
}

.service-content h3 {
  font-size: 14px;
  margin: 0 0 4px;
  color: #333;
}

.service-content p {
  font-size: 12px;
  margin: 0;
  color: #999;
}

.service-item .el-icon-arrow-right {
  color: #999;
  margin-left: 10px;
  transition: all 0.3s;
}

.service-item:hover .el-icon-arrow-right {
  color: #409eff;
  transform: translateX(4px);
}

/* 无外边距的表单项 */
.no-margin /deep/ .el-form-item__content {
  margin-left: 0 !important;
}

/* 响应式调整 */
@media (max-width: 768px) {
  .brands-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .action-buttons {
    flex-direction: column;
  }

  .apply-btn,
  .download-btn {
    width: 100%;
  }

  .submit-btn {
    width: 100%;
  }

  .trade-in-form /deep/ .el-col {
    margin-bottom: 16px;
  }

  .trade-in-form /deep/ .el-col:last-child {
    margin-bottom: 0;
  }
}

/* 动画效果 */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.policy-card,
.subsidy-card,
.process-card,
.form-card,
.brands-card,
.faq-card,
.related-card {
  animation: fadeIn 0.5s ease-out forwards;
}

.policy-card {
  animation-delay: 0.1s;
}
.subsidy-card {
  animation-delay: 0.2s;
}
.process-card {
  animation-delay: 0.3s;
}
.form-card {
  animation-delay: 0.4s;
}
.brands-card {
  animation-delay: 0.5s;
}
.faq-card {
  animation-delay: 0.6s;
}
.related-card {
  animation-delay: 0.7s;
}
</style>
